import type {
  MeshBatchSourceMap,
  MeshBatchSourceRecord,
  MeshBatchSourceRef,
} from '@/plugins/mesh/types'

/** 默认批次来源映射实现。 */
export class MeshBatchSourceMapImpl implements MeshBatchSourceMap {
  readonly byBatchId: ReadonlyMap<string, MeshBatchSourceRecord>

  constructor(records: readonly MeshBatchSourceRecord[]) {
    this.byBatchId = new Map(records.map((record) => [record.batchId, record]))
  }

  resolveInstance(batchId: string, instanceId: number): MeshBatchSourceRef | undefined {
    const record = this.byBatchId.get(batchId)
    if (record?.kind !== 'instanced') return undefined
    return record.instances.find((instance) => instance.instanceId === instanceId)
  }

  resolveRange(batchId: string, index: number): MeshBatchSourceRef | undefined {
    const record = this.byBatchId.get(batchId)
    if (record?.kind !== 'merged') return undefined
    return record.ranges.find((range) => index >= range.start && index < range.start + range.count)
  }
}
